import React from 'react';
import classNameBind from 'classnames/bind';
import Label from '../../../Label';
import Icon from '../../../Icon';
import styles from './TreeSelectionListDefaultActivator.module.css';

const bindClasses = classNameBind.bind(styles);

export default function TreeSelectionListDefaultActivator({ dataId, disabled, current }) {
  return (
    <div
      className={bindClasses('select', { disabled })}
      data-ppuc-id={`${dataId}.value`}
    >
      <span className={bindClasses('label')}>
        <Label
          noSelect
          title=""
        >
          {current}
        </Label>
      </span>
      <Icon
        name="chevron-down"
        className={bindClasses('icon')}
      />
    </div>
  );
}
